import { ref, watch, computed, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { MdTypography, MdButton, MdIconEdit, MdIconMerge, MdIconSearch, MdModal, MdIconMoveFolder, MdIconClose, MdIconEmptyTrash, MdSpinner, MdIconApplications, MdIconMoney, MdIconFonts, MdIconKebabMenu, MdIconUser, MdIconTag,MdIconSubset, MdIconSort, MdIconFoundrise } from '@antiqua-dls/vue-components'

import { CJA_EVENTS, LINK_TYPES, LINK_CATEGORIES, LINK_SECTION, LINK_NAMES } from '../../../../../../../modules/adobe-cja/constants'
import { adobeCjaEventEmitter } from '../../../../../../../modules/adobe-cja/utils'
import { ACTION_TYPES, ACTION_ICON_MAP, ACTION_EVENT_MAP, ACTION_POSITION } from '../constants/action-types'

export default {
    name: 'BulkActionTitleBar',
    components: {
        MdTypography,
        MdButton,
        MdIconSearch,
        MdModal,
        MdIconEdit,
        MdIconMerge,
        MdIconMoveFolder,
        MdIconClose,
        MdIconEmptyTrash,
        MdSpinner,
        MdIconApplications,
        MdIconMoney,
        MdIconFonts,
        MdIconKebabMenu,
        MdIconUser,
        MdIconTag,
        MdIconSubset,
        MdIconSort,
        MdIconFoundrise
    },
    emits: [
      'close-title-bar', 
      'action-clicked', 
      'update:showTitleBar',
      // Legacy event names for backward compatibility
      'open-search-modal',
      'open-edit-modal',
      'open-edit-price-modal',
      'open-mapFont-modal',
      'open-moveFont-modal',
      'more-option-clicked',
      'edit-designer-clicked',
      'add-tags-clicked',
      'auto-sort-clicked',
      'bulk-refine-styles-clicked',
      'open-bulk-refine-styles-modal', 'open-split-family-modal'
    ],
    props: {
    // Core props
        selectedCount: {
            type: Number,
            default: 0
        },
    showTitleBar: {
      type: Boolean,
      default: false
    },
    componentName: {
      type: String,
      default: ''
    },
    usedForFamily: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    },
    deleteConfig: {
      type: Object,
      default: () => ({
        visible: false,
        modalText: {},
        action: () => {},
        loading: false
      })
    },

        searchBarText: {
            type: String,
            default: ''
        },
        showSearchBar: {
            type: Boolean,
            default: false
        },
        editText: {
            type: String,
            default: ''
        },
        editPriceText: {
            type: String,
            default: ''
        },
        editDesignerText: {
            type: String,
            default: ''
        },
        mapFontText: {
            type: String,
            default: ''
        },
    firstBtnText: {
      type: String,
      default: ''
    },
    moveFontText: {
      type: String,
      default: ''
    },
    editBulkRefineStylesText: {
      type: String,
      default: ''
    },
    addTagsText: {
      type: String,
      default: 'Add tags'
    },
    autoSortText: {
      type: String,
      default: 'Auto sort styles'
        },
        showFirstBtn: {
            type: Boolean,
            default: false
        },
        showEdit: {
            type: Boolean,
            default: false
        },
        showBulkEditContract: {
            type: Boolean,
            default: false
        },
        showEditPrice: {
            type: Boolean,
            default: false
        },
        showBulkEditPrice: {
            type: Boolean,
            default: false
        },
        splitFamilyProps: {
            type: Object,
            default: () => ({
                showSplitFamily: false,
                splitFamilyText: ''
            })
        },
        showBulkRefineStyles: {
            type: Boolean,
            default: false
        },
        showEditDesigner: {
            type: Boolean,
            default: false
        },
        showMapFontAction: {
            type: Boolean,
            default: false
        },
        showMoveFont: {
            type: Boolean,
            default: false
        },
        showDeleteIcon: {
            type: Boolean,
            default: false
        },
        deleteModalText: {
            type: Object,
      default: () => ({})
        },
        deleteAction: {
            type: Function,
      default: () => {}
        },
        deleteSelectedFileLoading: {
            type: Boolean,
            default: false
        },
        showMoreDropdown: {
            type: Boolean,
            default: false
        },
        moreDropdownOptions: {
            type: Array,
            default: () => []
        },
        addTagsText: {
            type: String,
            default: 'Add tags'
        },
        autoSortText: {
            type: String,
            default: 'Auto sort styles'
        },
        editBulkDisplayFamilyText: {
            type: String,
            default: ''
        }
    },
  setup(props, { emit }) {
        const store = useStore()
        const showDeleteModal = ref(false)
        const showMoveFontAction = ref(false)
        const isMoreDropdownOpen = ref(false)
    const isNavBarOpen = computed(() => store.getters['sideNavigation/getNavBarState'] ?? true)

    const computedActions = computed(() => {
      if (props.actions && props.actions.length > 0) {
        return props.actions.filter(action => action.visible !== false)
      }
      const legacyActions = []

      if (props.showSearchBar) {
        legacyActions.push({
          type: ACTION_TYPES.SEARCH,
          text: props.searchBarText,
          position: ACTION_POSITION.RIGHT,
          slotName: 'search'
        })
      }

      if (props.showFirstBtn) {
        legacyActions.push({
          type: ACTION_TYPES.SEARCH,
          text: props.firstBtnText,
          position: ACTION_POSITION.RIGHT,
          event: 'first-btn-click-event',
          dataQaId: 'first-btn',
          slotName: 'firstBtn'
        })
      }

      if (props.showEdit) {
        legacyActions.push({
          type: ACTION_TYPES.EDIT,
          text: props.editText,
          position: ACTION_POSITION.RIGHT,
          slotName: 'edit'
        })
      }

      if (props.showBulkEditContract) {
        legacyActions.push({
          type: ACTION_TYPES.BULK_EDIT_CONTRACT,
          text: props.editText,
          position: ACTION_POSITION.RIGHT,
          slotName: 'edit'
        })
      }

      if (props.showEditPrice || props.showBulkEditPrice) {
        legacyActions.push({
          type: props.showBulkEditPrice ? ACTION_TYPES.BULK_EDIT_PRICE : ACTION_TYPES.EDIT_PRICE,
          text: props.editPriceText,
          position: ACTION_POSITION.RIGHT,
          slotName: 'editPrice'
        })
      }

      if (props.showBulkRefineStyles) {
        legacyActions.push({
          type: ACTION_TYPES.BULK_REFINE_STYLES,
          text: props.editBulkRefineStylesText,
          position: ACTION_POSITION.RIGHT,
          slotName: 'editBulkRefineStyles'
        })
      }

      if (props.showMapFontAction) {
        legacyActions.push({
          type: ACTION_TYPES.MAP_FONT,
          text: props.mapFontText,
          position: ACTION_POSITION.RIGHT,
          iconRotate: 'right'
        })
      }

      if (props.showMoveFont) {
        legacyActions.push({
          type: ACTION_TYPES.MOVE_FONT,
          text: props.moveFontText,
          position: ACTION_POSITION.RIGHT,
          slotName: 'moveFont'
        })
      }

      return legacyActions
    })

    /**
     * Computed property for actions in "More" dropdown
     */
    const moreMenuActions = computed(() => {
      const actions = []

      // From new API
      const newMoreActions = computedActions.value.filter(
        action => action.position === ACTION_POSITION.MORE_MENU
      )
      actions.push(...newMoreActions)

      // From legacy props
      if (props.showEditDesigner || props.showMoreDropdown) {
        actions.push({
          type: ACTION_TYPES.EDIT_DESIGNER,
          text: props.editDesignerText,
          event: 'edit-designer-clicked'
        })
      }

      if (props.showMoreDropdown) {
        actions.push(
          {
            type: ACTION_TYPES.ADD_TAGS,
            text: props.addTagsText,
            event: 'add-tags-clicked'
          },
          {
            type: ACTION_TYPES.AUTO_SORT_STYLES,
            text: props.autoSortText,
            event: 'auto-sort-clicked'
          }
        )
      }

      return actions
    })

    /**
     * Computed property for main action items (not in More menu)
     */
    const mainActions = computed(() => {
      return computedActions.value.filter(
        action => action.position !== ACTION_POSITION.MORE_MENU
      )
    })

    /**
     * Computed property for delete configuration
     */
    const deleteConfiguration = computed(() => {
      // Use new deleteConfig if provided
      if (props.deleteConfig && props.deleteConfig.visible !== undefined) {
        return props.deleteConfig
      }

      // Otherwise, use legacy props
      return {
        visible: props.showDeleteIcon,
        modalText: props.deleteModalText,
        action: props.deleteAction,
        loading: props.deleteSelectedFileLoading
      }
    })

    /**
     * Whether to show the More dropdown
     */
    const showMoreMenu = computed(() => {
      return moreMenuActions.value.length > 0
    })

    /**
     * Get icon component for an action
     */
    const getIconComponent = (action) => {
      return action.icon || ACTION_ICON_MAP[action.type] || 'MdIconEdit'
    }

    /**
     * Get event name for an action
     */
    const getEventName = (action) => {
      return action.event || ACTION_EVENT_MAP[action.type] || 'action-clicked'
    }

    /**
     * Get data-qa-id for an action
     */
    const getDataQaId = (action) => {
      if (action.dataQaId) return action.dataQaId
      
      // Generate from type
      const typeMap = {
        [ACTION_TYPES.SEARCH]: 'search',
        [ACTION_TYPES.EDIT]: 'edit',
        [ACTION_TYPES.EDIT_PRICE]: 'edit-price',
        [ACTION_TYPES.BULK_EDIT_CONTRACT]: 'bulk-edit-contract',
        [ACTION_TYPES.BULK_EDIT_PRICE]: 'bulk-edit-price',
        [ACTION_TYPES.BULK_REFINE_STYLES]: 'bulk-refine-styles',
        [ACTION_TYPES.MAP_FONT]: 'mapFont',
        [ACTION_TYPES.MOVE_FONT]: 'moveFont'
      }
      
      return typeMap[action.type] || action.type
    }

    /**
     * Handle action click
     */
    const handleActionClick = (action) => {
      const eventName = getEventName(action)
      
      // Emit specific event
      emit(eventName, action)
      
      // Also emit generic action-clicked event with action details
      emit('action-clicked', {
        type: action.type,
        action: action
      })
    }

    /**
     * Handle More menu option click
     */
    const handleMoreOptionClick = (action) => {
      const eventName = getEventName(action)
      
      // For backward compatibility with string-based option
      if (typeof action === 'string') {
        emit('more-option-clicked', action)
      } else {
        emit(eventName, action)
        emit('action-clicked', {
          type: action.type,
          action: action
        })
      }
      
      closeMoreDropdown()
    }

        const openDeleteModal = () => {
            showDeleteModal.value = true
        }

        const closeDeleteModal = () => {
            showDeleteModal.value = false
        }

        const closeTitleBar = () => {
            showDeleteModal.value = false
            emit('close-title-bar')
            emit('update:showTitleBar', false)
        }
        
        const toggleMoreDropdown = () => {
            isMoreDropdownOpen.value = !isMoreDropdownOpen.value
        }
        
        const closeMoreDropdown = () => {
            isMoreDropdownOpen.value = false
        }

        const handleSplitFamilyClick = () => {
            // Send Adobe analytics event
            adobeCjaEventEmitter({
              event: CJA_EVENTS.LINK_CLICK,
              links: {
                linkCategory: LINK_CATEGORIES.INVENTORY_INGESTION_HUB,
                linkSection: LINK_SECTION.BOTTOM_ACTION_BAR,
                linkName: LINK_NAMES.SPLIT_FAMILY,
                linkType: LINK_TYPES.BUTTON
              }
            });
            // Emit the original event to open the modal
            emit('open-split-family-modal')
        }

        const handleBulkRefineStylesClick = () => {
            // Send Adobe analytics event
            adobeCjaEventEmitter({
              event: CJA_EVENTS.LINK_CLICK,
              links: {
                linkCategory: LINK_CATEGORIES.INVENTORY_INGESTION_HUB,
                linkSection: LINK_SECTION.BOTTOM_ACTION_BAR,
                linkName: LINK_NAMES.REFINE_DISPLAY_STYLE_NAME,
                linkType: LINK_TYPES.BUTTON
              }
            });
            // Emit the original event to open the modal
            emit('open-bulk-refine-styles-modal')
        }

        // Add click outside handler to close dropdown
        const handleClickOutside = (event) => {
            if (isMoreDropdownOpen.value) {
                const dropdownContainer = event.target.closest('.moreDropdownContainer')
                const dropdownMenu = event.target.closest('.moreDropdown')
                
                if (!dropdownContainer && !dropdownMenu) {
                    closeMoreDropdown()
                }
            }
        }

        // Add event listener for click outside
        watch(isMoreDropdownOpen, (isOpen) => {
            if (isOpen) {
                setTimeout(() => {
                    document.addEventListener('click', handleClickOutside)
                }, 0)
            } else {
                document.removeEventListener('click', handleClickOutside)
            }
        })

        watch(() => props.showMoveFont, (value) => {
            showMoveFontAction.value = value
        }, { immediate: true })

        // Reset modal state when title bar is hidden
        watch(() => props.showTitleBar, (isVisible) => {
            if (!isVisible) {
                showDeleteModal.value = false
            }
        })

        // Cleanup event listener on unmount
        onUnmounted(() => {
            document.removeEventListener('click', handleClickOutside)
        })

        return {
      // State
            showDeleteModal,
            showMoveFontAction,
      isMoreDropdownOpen,
      isNavBarOpen,
      
      // Computed
      computedActions,
      mainActions,
      moreMenuActions,
      deleteConfiguration,
      showMoreMenu,
      
      // Methods
      openDeleteModal,
            closeDeleteModal,
            closeTitleBar,
            toggleMoreDropdown,
            closeMoreDropdown,
      handleClickOutside,
      handleActionClick,
            handleMoreOptionClick,
            handleSplitFamilyClick,
            handleBulkRefineStylesClick,
      getIconComponent,
      getEventName,
      getDataQaId,
      
      // Constants
      ACTION_TYPES,
      ACTION_POSITION
        }
    }
}
